import './App.css';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { lightTheme } from './Theme';
import Layout from "./Layout/index"
import Dashboard from './Pages/Dashboard';
import VendorManagement from './Pages/VendorManagement';
import AppCommonActionsWrapper from './Component/Common/appCommonActionsWrapper';
import Inventory from './Pages/Inventory';
import Unit from './Pages/Inventory/Common/Unit';
import CompanyName from './Pages/Inventory/Common/CompanyName';
import Group from './Pages/Inventory/Common/Group';
import SubGroup from './Pages/Inventory/Common/SubGroup';
import Size from './Pages/Inventory/Common/Size';
import Color from './Pages/Inventory/Common/Color';
import TypeOfPaper from './Pages/Inventory/TypeOfPaper';
import Micron from './Pages/Inventory/Micron';
import ChemicalName from './Pages/Inventory/ChemicalName';
import ChemicalCategory from './Pages/Inventory/ChemicalCategory';
import ChemicalCode from './Pages/Inventory/ChemicalCode';
import PantonNumber from './Pages/Inventory/PantonNumber';
import PurchaseOrder from './Pages/PurchaseOrder';
import PurchaseOrderDocuments from './Pages/PurchaseOrderDocuments';
import Documents from './Pages/Documents';
import PurchaseEntry from './Pages/PurchaseEntry';
import LotNumberList from './Pages/PurchaseEntry/LotNumberList';
import GrnNumber from './Pages/PurchaseEntry/GrnNumber';
import Production from './Pages/PurchaseEntry/Production';
import ProcessingUnitList from './Pages/ProcessingUnitList';
import Invoice from './Pages/Invoice';
import UserAndRole from './Pages/UserAndRole';
import Login from './Pages/Login';
import ForgotPassword from './Pages/ForgotPassword';
import OtpVerification from './Pages/OtpVerification';
import EnterPassword from './Pages/EnterPassword';
import { getPermission } from './Redux/Actions/RoleManagement';
import { useEffect } from 'react';
import localStoreUtil from './ApiSetUp/localstore.util';
import { LOGIN_TOKEN } from './ApiSetUp/AuthApi';
import { useDispatch } from 'react-redux';
import { ProtectedRoutes } from './Routes/ProtectedRoutes';
import Notification from './Pages/Notification';
import ReleaseStatus from './Pages/Inventory/Common/ReleaseStatus';
import Product from './Pages/Inventory/Common/Product';

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let login_Token = localStoreUtil.get_data(LOGIN_TOKEN)
  let Time = localStoreUtil.get_data("Time")
  useEffect(() => {
    if (login_Token) {
      const currentTime = new Date().getTime();
      const timeDifference = currentTime - parseInt(Time, 10);
      const oneDay = 24 * 60 * 60 * 1000;
      if (timeDifference > oneDay) {
        localStoreUtil.remove_all();
        navigate("/login")
      }
      (async () => {
        if (typeof window != "undefined") {
          const data = await dispatch(getPermission());
          if (data?.payload?.code == 0) {
            navigate("/login")
          } else {
          }
        }
      })();
    }
  }, [login_Token]);

  useEffect(() => {
    if (!login_Token) return;

    let timeoutId;
    const IDLE_TIMEOUT = 60 * 60 * 1000; // 1 hour

    const resetTimer = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        localStoreUtil.remove_all();
        navigate("/login");
      }, IDLE_TIMEOUT);
    };

    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    resetTimer(); // Initialize timer

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [login_Token, navigate]);

  return (
    <ThemeProvider theme={lightTheme}>
      <AppCommonActionsWrapper />
      <Layout>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/otp-verification' element={<OtpVerification />} />
          <Route path='/enter-password' element={<EnterPassword />} />

          <Route element={<ProtectedRoutes />} >
            <Route path='/' element={<Dashboard />} />
            <Route path='/notification' element={<Notification />} />

            <Route path='/vendor-management' element={<VendorManagement />} />

            <Route path='/purchase-order' element={<PurchaseOrder />} />
            <Route path='/purchase-order/po-documents' element={<PurchaseOrderDocuments />} />

            <Route path='/processing-unit-list' element={<ProcessingUnitList />} />

            <Route path='/documents' element={<Documents />} />

            <Route path='/invoice' element={<Invoice />} />
            <Route path='/user-role' element={<UserAndRole />} />

            <Route path='/purchase-entry' element={<PurchaseEntry />} />
            <Route path='/purchase-entry/lot-number-list' element={<LotNumberList />} />
            <Route path='/purchase-entry/grn-number' element={<GrnNumber />} />
            <Route path='/purchase-entry/production' element={<Production />} />

            <Route path='/inventory' element={<Inventory />} />
            <Route path='/inventory/common/unit' element={<Unit />} />
            <Route path='/inventory/common/company-name' element={<CompanyName />} />
            <Route path='/inventory/common/group' element={<Group />} />
            <Route path='/inventory/common/sub-group' element={<SubGroup />} />
            <Route path='/inventory/common/size' element={<Size />} />
            <Route path='/inventory/common/color' element={<Color />} />
            <Route path='/inventory/common/release-status' element={<ReleaseStatus />} />
            <Route path='/inventory/type-of-paper' element={<TypeOfPaper />} />
            <Route path='/inventory/micron' element={<Micron />} />
            <Route path='/inventory/chemical-name' element={<ChemicalName />} />
            <Route path='/inventory/chemical-category' element={<ChemicalCategory />} />
            <Route path='/inventory/chemical-code' element={<ChemicalCode />} />
            <Route path='/inventory/pantone-number' element={<PantonNumber />} />
            <Route path='/inventory/product' element={<Product />} />
          </Route>
        </Routes>
      </Layout>
    </ThemeProvider>
  );
}

export default App;
